// extracted by mini-css-extract-plugin
export default {"timer":"increase-quotation-hours-modal_timer__U2bgZ","counter":"increase-quotation-hours-modal_counter__Wcr68"};